import { message } from "antd";
import { makeAutoObservable } from "mobx";
import { IShortTask } from "../../models/ticket";
import { TaskService } from "../../services/task-service";

export default class ShortTaskStore {

    task: IShortTask;

    mathTaskService: TaskService;

    constructor(task: IShortTask) {
        this.task = task;
        this.mathTaskService = new TaskService();

        makeAutoObservable(this);
    }

    updateAnswer(value: string) {
        this.task.answer = value;
    }

    saveAnswer() {

        if (this.task.answer) {
            this.mathTaskService.updateAnswer(
                this.task.id, this.task.answer,
                () => message.success("Ответ успешно сохранён!")
            );
        }
    }
}